/**
 * Shared helpers for communications template editors (SMS + email).
 * Converts {{variable}} tokens to human-readable chips and back.
 */

const TOKEN_PATTERN = /\{\{\s*([^}]+?)\s*\}\}/g;

export const normalizeVariableCode = (code) => (code || '').trim();

export const findVariable = (variables, code) => {
  const normalized = normalizeVariableCode(code);
  return variables.find((item) => normalizeVariableCode(item.value) === normalized);
};

export const variableChipLabel = (variable, code) => {
  const match = variable || {};
  return (match.description || match.label || normalizeVariableCode(code) || '').trim();
};

/** Build HTML with {{code}} tokens replaced by styled chip spans. */
export const tokenToHtml = (text, variables) => {
  if (!text) return '';
  return text.replace(TOKEN_PATTERN, (match, code) => {
    const normalized = normalizeVariableCode(code);
    const variable = findVariable(variables, normalized);
    const label = variableChipLabel(variable, normalized);
    return `<span data-variable="{{${normalized}}}" contenteditable="false" style="background-color:#dbeafe;padding:3px 8px;border-radius:4px;color:#1e40af;font-weight:500;border:1px dashed #3b82f6;display:inline-block;margin:0 2px;cursor:default;max-width:100%;white-space:normal;word-break:break-word;">${label}</span>`;
  });
};

/** Extract plain text with chip spans converted back to {{code}} tokens. */
export const htmlToToken = (html) => {
  const div = document.createElement('div');
  div.innerHTML = html;
  div.querySelectorAll('[data-variable]').forEach((el) => {
    el.replaceWith(el.getAttribute('data-variable') || '');
  });
  return div.innerText
    .replace(/\u00a0/g, ' ')
    .replace(/  +/g, ' ')
    .trim();
};

export const buildVariableChipHtml = (variable) => {
  const code = normalizeVariableCode(variable.value);
  const label = variableChipLabel(variable, code);
  return `<span data-variable="{{${code}}}" contenteditable="false" style="background-color:#dbeafe;padding:3px 8px;border-radius:4px;color:#1e40af;font-weight:500;border:1px dashed #3b82f6;display:inline-block;margin:0 2px;cursor:default;max-width:100%;white-space:normal;word-break:break-word;">${label}</span>&nbsp;`;
};
